export default __webpack_public_path__ + "static/media/rating-solid-watch-outline.28fb3d33.svg";